import type { Topic } from "@/types/content";

export const topicTags = [
  "影视热议",
  "明星动态",
  "票房口碑",
  "行业观察",
  "社会话题",
  "幕后故事",
];

export const topics: Topic[] = [
  {
    id: "topic-01",
    title: "《星海回声》口碑爆棚：国产科幻的又一次漂亮突围",
    tag: "影视热议",
    date: "2025-10-06",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20entertainment%20news%20image%20of%20a%20glowing%20cinema%20screen%20in%20a%20dark%20theater%20with%20audience%20silhouettes%2C%20deep%20blue%20ambience%20with%20warm%20orange%20projector%20light%2C%20modern%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=topic-01&orientation=landscape",
    excerpt:
      "上映首周末斩获同期票房冠军，社交平台上关于结局的多重解读持续发酵。",
    content: [
      {
        type: "text",
        value:
          "《星海回声》上映以来口碑一路走高，首周末票房位列同期第一。观众讨论的焦点，集中在影片开放式的结局与那段神秘信号的真正含义上。",
      },
      {
        type: "image",
        value:
          "https://readdy.ai/api/search-image?query=Editorial%20cinema%20feature%20image%20of%20a%20solitary%20astronaut%20silhouette%20against%20a%20vast%20starry%20nebula%2C%20deep%20navy%20blue%20with%20warm%20orange%20light%20accent%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=1200&height=675&seq=topic-01-b&orientation=landscape",
      },
      {
        type: "text",
        value:
          "不少影评人认为，影片真正动人的并非视觉奇观，而是它对「选择」与「记忆」的追问。故事里每一次回望，其实都是对现实的一次提问。",
      },
      {
        type: "text",
        value:
          "与此同时，关于续作的猜测也在升温。制片方目前尚未给出明确回应，只表示「一切都在认真筹备中」。",
      },
    ],
    filmIds: ["film-01"],
    starIds: ["star-01", "star-02"],
  },
  {
    id: "topic-02",
    title: "悬疑剧为何越来越「克制」？从《长夜将明》说起",
    tag: "行业观察",
    date: "2025-09-29",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20foggy%20night%20city%20alley%20with%20a%20single%20street%20lamp%2C%20deep%20blue%20shadows%20with%20warm%20orange%20glow%2C%20modern%20magazine%20style%2C%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=topic-02&orientation=landscape",
    excerpt:
      "越来越多悬疑作品放弃了强刺激，转向安静的调查与缓慢的真相。",
    content: [
      {
        type: "text",
        value:
          "近几年，一批悬疑作品开始刻意降低血腥与刺激的比重，把笔墨放在人物与调查过程上，《长夜将明》就是其中的代表。",
      },
      {
        type: "image",
        value:
          "https://readdy.ai/api/search-image?query=Editorial%20news%20feature%20image%20of%20a%20detective%20notebook%20and%20old%20photographs%20on%20a%20wooden%20desk%2C%20deep%20blue%20tone%20with%20warm%20orange%20lamp%20light%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=1200&height=675&seq=topic-02-b&orientation=landscape",
      },
      {
        type: "text",
        value:
          "观众的口味在变化，创作者也在成长。当悬念不再依赖感官冲击，故事本身的密度就成了唯一的支撑。",
      },
    ],
    filmIds: ["film-02"],
    starIds: ["star-03", "star-04"],
  },
  {
    id: "topic-03",
    title: "老戏骨回归荧幕：为什么年代剧总能让人破防",
    tag: "影视热议",
    date: "2025-09-20",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20misty%20ancient%20mountains%20at%20golden%20dawn%20with%20a%20distant%20pagoda%2C%20deep%20blue%20haze%20with%20warm%20orange%20sunrise%20light%2C%20modern%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=topic-03&orientation=landscape",
    excerpt:
      "从《山河故人梦》到多部新剧，年代题材在年轻观众中意外走红。",
    content: [
      {
        type: "text",
        value:
          "年代剧正在被越来越多年轻观众接受。它们用缓慢的节奏和扎实的细节，讲述被时间掩埋的普通人故事。",
      },
      {
        type: "text",
        value:
          "江怀瑾、苏晚棠等演员的表演，让观众相信那些人物真实存在过。有网友说：「看完只想给家里打个电话。」",
      },
    ],
    filmIds: ["film-03"],
    starIds: ["star-05", "star-06"],
  },
  {
    id: "topic-04",
    title: "国庆档观察：票房回暖背后，观众在为什么买单",
    tag: "票房口碑",
    date: "2025-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20crowded%20cinema%20lobby%20with%20warm%20lights%20and%20poster%20walls%2C%20deep%20blue%20ambience%20with%20warm%20orange%20accents%2C%20modern%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=topic-04&orientation=landscape",
    excerpt:
      "类型多元、口碑驱动，今年的观影决策比以往更依赖真实评价。",
    content: [
      {
        type: "text",
        value:
          "今年国庆档整体票房稳中有升，观众的选择比过去更理性：不再是单纯的明星驱动，而是口碑与题材双重考量。",
      },
      {
        type: "text",
        value:
          "喜剧、科幻与现实题材各占一席，这种多元格局被业内视为健康信号。",
      },
    ],
    filmIds: ["film-07", "film-11"],
    starIds: ["star-08", "star-04"],
  },
  {
    id: "topic-05",
    title: "从演员到制片人：女演员的转型正在改变行业",
    tag: "明星动态",
    date: "2025-09-12",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20film%20production%20storyboard%20and%20clapperboard%20on%20a%20desk%2C%20deep%20blue%20tone%20with%20warm%20orange%20light%2C%20minimal%20modern%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=topic-05&orientation=landscape",
    excerpt:
      "越来越多女演员走到幕后，用制片人的身份推动更多元的题材。",
    content: [
      {
        type: "text",
        value:
          "林知遥等演员近年开始担任制片人，把目光投向女性题材与新人导演。这种转变，正在悄悄改变内容生产的生态。",
      },
      {
        type: "text",
        value:
          "她们带来的不仅是资源，更是一种视角的补充。",
      },
    ],
    filmIds: ["film-01"],
    starIds: ["star-01", "star-07", "star-09"],
  },
  {
    id: "topic-06",
    title: "观众最爱讨论的「演技瞬间」，到底在讨论什么",
    tag: "影视热议",
    date: "2025-08-25",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20an%20empty%20theater%20seat%20with%20dramatic%20stage%20spotlight%2C%20deep%20blue%20shadow%20with%20warm%20orange%20beam%2C%20minimal%20elegant%20magazine%20composition%2C%20high%20detail&width=800&height=500&seq=topic-06&orientation=landscape",
    excerpt:
      "一个眼神、一次停顿，为什么能让整场戏立住？",
    content: [
      {
        type: "text",
        value:
          "社交平台上，「演技瞬间」类的剪辑总能获得大量转发。观众迷恋的，其实是演员在细节里展现出的真实。",
      },
      {
        type: "text",
        value:
          "好表演不需要用力过猛，它更像是一种恰到好处的诚实。",
      },
    ],
    filmIds: ["film-08"],
    starIds: ["star-03", "star-05", "star-07", "star-08"],
  },
  {
    id: "topic-07",
    title: "沈亦舟执导短片入围影展，转型之路获认可",
    tag: "明星动态",
    date: "2025-10-02",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20director%20chair%20and%20camera%20on%20an%20empty%20film%20set%2C%20deep%20blue%20shadows%20with%20warm%20orange%20set%20light%2C%20minimal%20modern%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=topic-07&orientation=landscape",
    excerpt:
      "从演员到导演，他用一部短片证明了自己的另一种可能。",
    content: [
      {
        type: "text",
        value:
          "沈亦舟首次执导的短片入围国际影展，评审称赞其「克制的叙事与精准的镜头感」。",
      },
      {
        type: "text",
        value:
          "他本人则表示，执导让他重新理解了表演，「原来镜头后面是另一种孤独」。",
      },
    ],
    filmIds: ["film-06", "film-12"],
    starIds: ["star-02", "star-09"],
  },
  {
    id: "topic-08",
    title: "运动员跨界影视，是加分项还是双刃剑",
    tag: "行业观察",
    date: "2025-09-05",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20a%20running%20track%20at%20sunrise%20with%20dramatic%20long%20shadows%2C%20deep%20blue%20tone%20with%20warm%20orange%20sunrise%20light%2C%20minimal%20modern%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=topic-08&orientation=landscape",
    excerpt:
      "真实的身体素质与镜头表现力之间，还需要一座桥。",
    content: [
      {
        type: "text",
        value:
          "越来越多运动员走进影视行业。他们的身体表现力天然占优，但表演的细腻度仍需时间打磨。",
      },
      {
        type: "text",
        value:
          "谢听澜的转型被视作一个积极样本：他没有回避自己的短板，而是从最贴近经历的角色开始。",
      },
    ],
    filmIds: ["film-05", "film-10"],
    starIds: ["star-10", "star-06"],
  },
];